import React, { Component } from 'react';
import { Rect, Text, Group } from 'react-konva';

export class HorizontalStopsListComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const geometryWidthRatio = geometry.width / 1200.0 * dimentionsRatio;
        const geometryHeightRatio = geometry.height / 400.0 * dimentionsRatio;

        const textElementPosX = geometry.drawPositionX + 50 * geometryWidthRatio;
        const textElementPosY = geometry.drawPositionY + 350 * geometryHeightRatio;

        const componentSecundaryColor = "#C3E2F0";
        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;

        let fontSize = 35;
        if (6 * fontSize > geometryHeight) {
            fontSize = geometryHeight / 6.0;
        }
        if (fontSize > geometryWidth) {
            fontSize *= geometryWidth / fontSize;
        }

        const rectElements = [];
        let nextRectPosX = textElementPosX + fontSize + 10;
        const rectPosY = geometry.drawPositionY + 50 * geometryHeightRatio;
        const rectHeight = 300 * geometryHeightRatio;
        const rectWidth = 20;

        const widthLimit = geometryWidth + geometry.drawPositionX - 5;
        while (widthLimit > nextRectPosX + rectWidth) {
            rectElements.push(
                <Group key={nextRectPosX}>
                    <Rect x={nextRectPosX}
                        y={rectPosY}
                        width={rectWidth}
                        height={rectHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>
            );

            nextRectPosX += rectWidth + 10;
        }

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometryWidth}
                    height={geometryHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Text text="Espinha"
                        fontSize={fontSize}
                        x={textElementPosX}
                        y={textElementPosY}
                        rotation={-90} />
                </Group>

                {rectElements}
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/HorizontalStopsListComponentCanvas.js